export default "__VITE_ASSET__UuIaSGoJ__"